module.exports = __webpack_public_path__ + "img/logo_y.073c3307.png";